<template>
  <member-invite-flow />
</template>

<script>
import { mapActions } from 'vuex';
import MemberInviteFlow from '@/pages/responsive-pages/invite-authenticated/member-invite/MemberInviteFlow';

export default {
  name: 'InviteAuthenticateToken',
  components: {
    MemberInviteFlow,
  },
  async created() {
    this.startLoading(this.$options.name);
    const token = this.$route.query.inviteToken;
    await this.$store.dispatch('inviteSession/init', token);
    this.doneLoading(this.$options.name);
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
  },
};
</script>
